import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { UimJsonViewerComponent } from "@scisys-uim/uim-common/lib/json-viewer/json-viewer.component";
import { JustfoneDataTransferDebugService } from "assets-service";


@Component({
  selector: 'app-justfone-data-transfer-dialog',
  templateUrl: './justfone-data-transfer-dialog.component.html',
  styleUrls: ['./justfone-data-transfer-dialog.component.scss']
})
export class JustfoneDataTransferDialogComponent implements OnInit  {

  className: string;
  id: string;
  json: any;

  constructor(
    protected snackBar: MatSnackBar,
    protected dialogRef: MatDialogRef<JustfoneDataTransferDialogComponent, any>,
    @Inject(MAT_DIALOG_DATA) data: JustfoneDataTransferDialogData,
    fb: FormBuilder,
    dialog: MatDialog,
    configService: ConfigStorage,
    protected justfoneDataTransferDebugService: JustfoneDataTransferDebugService,
    userStorage: UserStorage) {
      this.className = data.className;
      this.id = data.id;
  }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    const self = this;
    this.json = {status: 'Fetching data...'};
    this.justfoneDataTransferDebugService.getEntityData(this.className, this.id).subscribe(data => {
      self.json = data;
    }, error => {
      self.json = {status: 'Error fetching data: ' + error.message, error: error};
    });
  }

  forceUpdate() {
    this.json = {status: 'Updating entity...'};
    this.justfoneDataTransferDebugService.forceCreateOrUpdateEntity(this.className, this.id).subscribe(data => {
      this.snackBar.open('Entity updated successfully', 'Close', {duration: 3000});
      this.fetchData();
    });
  }

  forceDelete() {
    this.json = {status: 'Deleting entity...'};
    this.justfoneDataTransferDebugService.forceDeleteEntity(this.className, this.id).subscribe(data => {
      this.snackBar.open('Entity deleted successfully', 'Close', {duration: 3000});
      this.fetchData();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}

export interface JustfoneDataTransferDialogData {
  className: string;
  id: string;
}

export function openJustfoneDataTransferDialog(dialog: MatDialog, className: string, id: string | number): void {
  dialog.open(JustfoneDataTransferDialogComponent, {
    width: '800px',
    panelClass: 'dialog-resizable',
    data: {
      className: className,
      id: ''+id,
    }
  })
}